var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#ADA7C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 17.3333C23.1987 17.3333 23.5625 17.6971 23.5625 18.1458V21.9375H27.3542C27.8029 21.9375 28.1667 22.3013 28.1667 22.75C28.1667 23.1987 27.8029 23.5625 27.3542 23.5625H23.5625V27.3542C23.5625 27.8029 23.1987 28.1667 22.75 28.1667C22.3013 28.1667 21.9375 27.8029 21.9375 27.3542V23.5625H18.1458C17.6971 23.5625 17.3333 23.1987 17.3333 22.75C17.3333 22.3013 17.6971 21.9375 18.1458 21.9375H21.9375V18.1458C21.9375 17.6971 22.3013 17.3333 22.75 17.3333ZM13 16.5208C13 14.5763 14.5763 13 16.5208 13H28.9792C30.9236 13 32.5 14.5763 32.5 16.5208V28.9792C32.5 30.9236 30.9236 32.5 28.9792 32.5H16.5208C14.5763 32.5 13 30.9236 13 28.9792V16.5208ZM16.5208 14.625C15.4738 14.625 14.625 15.4738 14.625 16.5208V28.9792C14.625 30.0262 15.4738 30.875 16.5208 30.875H28.9792C30.0262 30.875 30.875 30.0262 30.875 28.9792V16.5208C30.875 15.4738 30.0262 14.625 28.9792 14.625H16.5208Z",
    fill: "#1F1D28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddActive);
export default __webpack_public_path__ + "static/media/add-active.11392ab899abcf44beb10c44ddc2b8ad.svg";
export { ForwardRef as ReactComponent };